import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.singleItem || initialState;

export const selectSingleItem = createSelector([selectSlice], state => state);
export const selectSingleItemData = createSelector(
  [selectSlice],
  state => state.data,
);
export const selectSingleItemIsLoading = createSelector(
  [selectSlice],
  state => state.isLoading,
);
export const selectSingleItemError = createSelector(
  [selectSlice],
  state => state.error,
);
